"use strict";

import $ from "jquery";

/**
 * @copyright pikabu.ru, 2018
 */
class Sharer {
  constructor(el, delegate) {
    if (delegate) {
      $(el).on("click", delegate, this._openWindow.bind(this));
    } else {
      $(el).on("click", this._openWindow.bind(this));
    }
  }

  /**
   * @param {object} e jQuery Event
   * @private
   * @return {void}
   */
  _openWindow(e) {
    e.preventDefault();

    let w = 626,
      h = 436,
      pos = Sharer.getPositions(w, h);

    let newWindow = window.open(
      e.currentTarget.href,
      "Share Dialog",
      `width=${w}, height=${h}, top=${pos.top}, left=${pos.left}`
    );

    if (window.focus) {
      newWindow.focus();
    }
  }

  /**
   * @static
   * @see https://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen
   * @return {{top:number,left:number}}
   */
  static getPositions(w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    let dualScreenLeft =
      window.screenLeft != undefined ? window.screenLeft : window.screenX;
    let dualScreenTop =
      window.screenTop != undefined ? window.screenTop : window.screenY;

    let width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    let height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

    return {
      left: width / 2 - w / 2 + dualScreenLeft,
      top: height / 2 - h / 2 + dualScreenTop
    };
  }
}

export { Sharer };
